<template>
  <div>
    <form>
      <div class="dashboard-page-title">
        <div class="container-fluid">
          <h1>Manage Payment Details</h1>

          <a @click="$router.go(-1)" class="btn btn-info" active-class="">
            <i class="fa fa-chevron-left"></i> Back
          </a>
        </div>
      </div>

      <div class="container-fluid">
        <div class="dashboard-block w-full">
          <h2>Card Details</h2>
          <input id="card-holder-name" type="text" v-model="name" placeholder="Name on card" class="form-control">
          <div id="card-element"/>
          <div id="cvc-element"/>
          <div id="exp-element"/>
          <input id="default_payment_method" type="checkbox" v-model="default_payment_method"/>
          <label for="default_payment_method">Set as default?</label>
          <div class="spacer-t-2">
            <ladda-button
              type="submit"
              class="btn btn-sm btn-primary pull-right"
              :click="handleSaveCardDetailsCallback">
              Save Card Details
            </ladda-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { omit } from 'lodash'
import { stateMapper } from 'mixins/users/payment-details'
import { handleServerErrors } from 'utils/http'
import { helpers } from 'mixins/users'
import { helpers as profileHelpers } from 'mixins/profile'
import Selectize from '../ext/codium/CodiumSelectize'
import { notify } from 'utils'
import { loadStripe } from '@stripe/stripe-js'

export default {
  mixins: [helpers, stateMapper, profileHelpers],

  components: {
    Selectize
  },

  data () {
    return {
      stripe: null,
      card: null,
      name: '',
      addPaymentStatus: 0,
      addPaymentStatusError: '',
      checkoutSession: null,
      default_payment_method: false
    }
  },

  mounted () {
    this.setupStripe()
  },

  computed: {
    ...mapState('user', ['user']),

    /**
     * Options for the GST registered Selectize component.
     *
     * @return array
     */
    gstRegisteredOptions () {
      return [
        { id: true, text: 'Yes' },
        { id: false, text: 'No' }
      ]
    },

    currentYear () {
      return new Date().getFullYear()
    }
  },

  methods: {
    ...mapActions('user/paymentDetail', ['getUserPaymentDetails', 'updateUserPaymentDetails', 'saveCard']),

    loadIntent () {
      this.$http.get('/card/setup-intent/')
        .then(function (response) {
          this.intentToken = response.data
        }.bind(this))
    },
    async setupStripe () {
      this.loadIntent()
      this.stripe = await loadStripe(this.$stripePublicKey(this.$user.region.shortname))
      var elements = this.stripe.elements()

      this.cardNumber = elements.create('cardNumber', {
        showIcon: true
      })
      this.cardNumber.mount('#card-element')

      this.cardExpiry = elements.create('cardExpiry')
      this.cardExpiry.mount('#exp-element')

      this.cardCvc = elements.create('cardCvc')
      this.cardCvc.mount('#cvc-element')
    },
    async handleSaveCardDetailsCallback () {
      this.addPaymentStatus = 1
      const result = await this.stripe.confirmCardSetup(
        this.intentToken.client_secret, {
          payment_method: {
            card: this.cardNumber,
            billing_details: {
              name: this.name
            }
          }
        }
      ).then(result => {
        if (result.error) {
          this.addPaymentStatus = 3
          this.addPaymentStatusError = result.error.message
          notify.error(this.addPaymentStatusError)
        }
        return result
      })
      return this.savePaymentMethod(result.setupIntent.payment_method)
    },
    savePaymentMethod (method) {
      return this.$http.post('/card/payments/', {
        payment_method: method,
        default_payment_method: this.default_payment_method
      }).then(() => {
        notify.success('Successfully added card.')
        this.$router.push({ name: 'profile.show' })
      })
    },
    handleSavePaymentDetailsCallback () {
      return this.validate()
        .then(() => {
          return this.updateUserPaymentDetails({
            id: this.user.id,
            payload: omit(this.paymentDetails, ['id'])
          }).then(() => {
            notify.success('Successfully created payment details')
          }).catch((errors) => {
            notify.error('Sorry something went wrong saving your changes, please try again.')
            if (errors.response) {
              handleServerErrors(errors, this.errors)
            } else {
              throw errors
            }
          })
        })
    }
  }
}
</script>

<style>
.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 2px solid black;
  border-radius: 0;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  transition: box-shadow 150ms ease;
  margin: 20px 0;
  color:#555;
  font-family: inherit;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
